<div class="download-all">
  <button
    mat-stroked-button
    color="accent"
    [disabled]="!config || processing"
    (click)="onDownloadClick()"
  >
    Download All
  </button>
  <div
    class="processing"
    *ngIf="processing"
  >
    <mat-spinner [diameter]="15"></mat-spinner>
    <span>Processing...</span>
  </div>
</div>
